<template>
  <div class="border-t border-gray-300">
    <div class="mt-6">
      <RewardModal
        v-if="isRewardModalOpen"
        :rewardAmount="retributionConfiguration?.sellerNetAmount"
        :isSepaPayment="isSepaPayment"
      />
      <div v-else class="p-6 rounded-xl">
        <div class="flex flex-col items-center gap-2">
          <CheckCircleIcon class="h-8 w-8 text-green-400" />
          <p class="text-center font-bold text-lg">
            {{ $t("everything is good !") }}
          </p>
          <template v-if="!isSepaPayment">
            <p class="text-md text-center">La vente du contrat est bien enregistrée.</p>
            <p class="text-md text-center">
              Nous avons envoyé au client un e-mail de confirmation à l’adresse
              <span class="font-bold">{{ customer.email }}.</span>
            </p>
          </template>

          <template v-else>
            <p class="text-md text-center">La vente du contrat est bien enregistrée.</p>
            <p class="text-md text-center">
              Nous avons envoyé au client un e-mail de
              <span class="font-bold">pré-confirmation</span>
              à l’adresse
              <span class="font-bold">{{ customer.email }}.</span>
            </p>
            <div class="mt-2 rounded-md bg-gray-100 p-3">
              <p class="text-sm text-gray-700 text-center">
                Le traitement du paiement par prélèvement SEPA prend généralement
                <span class="font-semibold">5 à 10 jours ouvrés.</span>
                <br />
                La vente sera comptabilisée et visible dans votre espace
                <span class="font-semibold">une fois le paiement confirmé.</span>
                <br />
                <br />
                Vous pouvez suivre l’état de cette vente à tout moment dans la section
                <span class="font-semibold">Devis.</span>
              </p>
            </div>
          </template>
          <div v-if="showRewardButton" class="mt-4">
            <GenericButton @click="showRewardModal">Voir mes récompenses 🎁</GenericButton>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { CheckCircleIcon } from "@heroicons/vue/outline";
import { GenericButton, toCamelCase } from "@estaly/ui";
import { mapActions } from "vuex";
import RewardModal from "./RewardModal.vue";

export default {
  components: {
    CheckCircleIcon,
    GenericButton,
    RewardModal,
  },

  props: {
    customer: Object,
    matchedContractId: Number,
    isSepaPayment: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      retributionConfiguration: null,
      isRewardModalOpen: false,
    };
  },

  computed: {
    showRewardButton() {
      return this.retributionConfiguration?.sellerNetAmount > 0;
    },
  },

  watch: {
    matchedContractId: {
      immediate: true,
      handler(newMatchedContractId) {
        if (newMatchedContractId) {
          this.fetchRetributionConfiguration();
        }
      },
    },
  },

  methods: {
    ...mapActions("retributionConfigurations", ["fetchRetributionConfigurations"]),

    async fetchRetributionConfiguration() {
      if (!this.matchedContractId) return;

      const response = await this.fetchRetributionConfigurations({ matchedContractId: this.matchedContractId });
      if (!response?.success) return;

      const data = toCamelCase(response.data);

      this.retributionConfiguration = data.records?.[0];
    },

    showRewardModal() {
      this.isRewardModalOpen = true;
    },
  },
};
</script>
